// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/bg-cubic-sis.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TF8nE1V0RswyN8WYl_rw {
	--bg-spacing: 0px;

	height: 48px;
	width: 100%;
	display: flex;
	align-items: center;
	color: black;
	justify-content: center;
	gap: 24px;
	background-color: rgba(0, 87, 65, 0.9);
	font-size: 16px;
	padding: 8px;
	overflow: hidden;
	font-family: Inter, sans-serif;
}
.TF8nE1V0RswyN8WYl_rw > * {
	display: inline-flex;
}
.tuAiWtB58cxon2NXSivG {
	font-weight: 600;
	letter-spacing: 0.04em;
}
.Dn7OfW2TlgI7JW_xNNGs {
	transform: rotate(180deg);
	color: #fff;
	margin-left: 4px;
	width: 13px;
	height: 10px;
}
.pLBZC_TrOfo3CS6usLQO {
	display: flex;
	align-items: center;
}
@media (max-width: 768px) {
.pLBZC_TrOfo3CS6usLQO {
		display: none;
}
	}
._9XEg8dtbSKFFhfrGRCuA {
	color: #fff;
	background-color: #8147e0;
	background-color: var(--page-banner-bg, #8147e0);
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}),
		url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-repeat: no-repeat, no-repeat;
	background-position: left center, right center;
}
@media (max-width: 768px) {
._9XEg8dtbSKFFhfrGRCuA {
		background-image: none;
}
	}
._9XEg8dtbSKFFhfrGRCuA .IZEA82DrSe7Ne9f3cPln {
		display: none;
		align-items: center;
		font-weight: 400;
		font-size: 12px;
		line-height: 1.2;
		padding: 2px 6px;
		margin-right: 16px;
		text-transform: uppercase;
		font-weight: 600;
		border-radius: 5px;
		background-color: #fff;
		color: #8147e0;
		color: var(--page-banner-bg, #8147e0);
	}
@media (max-width: 767px) {

	._9XEg8dtbSKFFhfrGRCuA .IZEA82DrSe7Ne9f3cPln {
			display: flex;
			margin-right: 6px;
	}
		}
.r0_kkYPhvDa82uKaUAaH {
	--page-banner-bg: #8147e0;
}
.UBsGr8EQwWfyN3OnzrbG {
	--page-banner-bg: #2ea043;
}
.KdUWXBHzZTlREJqdl7nX {
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	color: white;
	text-wrap: nowrap;
}
@media (max-width: 420px) {
.KdUWXBHzZTlREJqdl7nX {
		font-size: 12px;
}
	}
.SkoMouxdxUxwDR04ZZfB {
	height: 28px;
	margin-left: 6px;
	margin-right: 6px;
}
@media (max-width: 1000px) {
	.TF8nE1V0RswyN8WYl_rw {
		--bg-spacing: 100px;
		gap: 12px;
		font-size: 14px;
		height: auto;
		padding: 15px;
	}
}
@media (max-width: 600px) {
	.TF8nE1V0RswyN8WYl_rw {
		--bg-spacing: 120px;
		gap: 10px;
		padding: 20px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/PageBanner/PageBanner.pcss"],"names":[],"mappings":"AAEA;CACC,iBAAiB;;CAEjB,YAAY;CACZ,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,YAAY;CACZ,uBAAuB;CACvB,SAAS;CACT,sCAAsC;CACtC,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB,8BAA8B;AAC/B;AAEA;CACC,oBAAoB;AACrB;AAEA;CACC,gBAAgB;CAChB,sBAAsB;AACvB;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,gBAAgB;CAChB,WAAW;CACX,YAAY;AACb;AAEA;CACC,aAAa;CACb,mBAAmB;AAKpB;AAHC;AAJD;EAKE,aAAa;AAEf;CADC;AAGD;CACC,WAAW;CACX,yBAAgD;CAAhD,gDAAgD;CAChD;yCACiC;CACjC,uCAAuC;CACvC,8CAA8C;AAyB/C;AAvBC;AARD;EASE,sBAAsB;AAsBxB;CArBC;AAEA;EACC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,cAAqC;EAArC,qCAAqC;CAMtC;AAJC;;CAdD;GAeE,aAAa;GACb,iBAAiB;CAEnB;EADC;AAIF;CACC,yBAAyB;AAC1B;AAEA;CACC,yBAAyB;AAC1B;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,YAAY;CACZ,iBAAiB;AAKlB;AAHC;AARD;EASE,eAAe;AAEjB;CADC;AAGD;CACC,YAAY;CACZ,gBAAgB;CAChB,iBAAiB;AAClB;AAEA;CACC;EACC,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,aAAa;CACd;AACD;AAEA;CACC;EACC,mBAAmB;EACnB,SAAS;EACT,aAAa;CACd;AACD","sourcesContent":["@import './../../stylesheets/media-queries.pcss';\n\n.container {\n\t--bg-spacing: 0px;\n\n\theight: 48px;\n\twidth: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tcolor: black;\n\tjustify-content: center;\n\tgap: 24px;\n\tbackground-color: rgba(0, 87, 65, 0.9);\n\tfont-size: 16px;\n\tpadding: 8px;\n\toverflow: hidden;\n\tfont-family: Inter, sans-serif;\n}\n\n.container > * {\n\tdisplay: inline-flex;\n}\n\n.titleContainer {\n\tfont-weight: 600;\n\tletter-spacing: 0.04em;\n}\n\n.arrowIcon {\n\ttransform: rotate(180deg);\n\tcolor: #fff;\n\tmargin-left: 4px;\n\twidth: 13px;\n\theight: 10px;\n}\n\n.description {\n\tdisplay: flex;\n\talign-items: center;\n\n\t@media (max-width: 768px) {\n\t\tdisplay: none;\n\t}\n}\n\n.symbiosisStakingContainer {\n\tcolor: #fff;\n\tbackground-color: var(--page-banner-bg, #8147e0);\n\tbackground-image: url('./assets/bg-cubic-sis.png'),\n\t\turl('./assets/bg-cubic-sis.png');\n\tbackground-repeat: no-repeat, no-repeat;\n\tbackground-position: left center, right center;\n\n\t@media (max-width: 768px) {\n\t\tbackground-image: none;\n\t}\n\n\t.new {\n\t\tdisplay: none;\n\t\talign-items: center;\n\t\tfont-weight: 400;\n\t\tfont-size: 12px;\n\t\tline-height: 1.2;\n\t\tpadding: 2px 6px;\n\t\tmargin-right: 16px;\n\t\ttext-transform: uppercase;\n\t\tfont-weight: 600;\n\t\tborder-radius: 5px;\n\t\tbackground-color: #fff;\n\t\tcolor: var(--page-banner-bg, #8147e0);\n\n\t\t@media (--mobile) {\n\t\t\tdisplay: flex;\n\t\t\tmargin-right: 6px;\n\t\t}\n\t}\n}\n\n.polRewardBanner {\n\t--page-banner-bg: #8147e0;\n}\n\n.ethCommissionBanner {\n\t--page-banner-bg: #2ea043;\n}\n\n.text {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: relative;\n\tcolor: white;\n\ttext-wrap: nowrap;\n\n\t@media (max-width: 420px) {\n\t\tfont-size: 12px;\n\t}\n}\n\n.img {\n\theight: 28px;\n\tmargin-left: 6px;\n\tmargin-right: 6px;\n}\n\n@media (max-width: 1000px) {\n\t.container {\n\t\t--bg-spacing: 100px;\n\t\tgap: 12px;\n\t\tfont-size: 14px;\n\t\theight: auto;\n\t\tpadding: 15px;\n\t}\n}\n\n@media (max-width: 600px) {\n\t.container {\n\t\t--bg-spacing: 120px;\n\t\tgap: 10px;\n\t\tpadding: 20px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TF8nE1V0RswyN8WYl_rw`,
	"titleContainer": `tuAiWtB58cxon2NXSivG`,
	"arrowIcon": `Dn7OfW2TlgI7JW_xNNGs`,
	"description": `pLBZC_TrOfo3CS6usLQO`,
	"symbiosisStakingContainer": `_9XEg8dtbSKFFhfrGRCuA`,
	"new": `IZEA82DrSe7Ne9f3cPln`,
	"polRewardBanner": `r0_kkYPhvDa82uKaUAaH`,
	"ethCommissionBanner": `UBsGr8EQwWfyN3OnzrbG`,
	"text": `KdUWXBHzZTlREJqdl7nX`,
	"img": `SkoMouxdxUxwDR04ZZfB`
};
export default ___CSS_LOADER_EXPORT___;
